export enum ErrorMessage {
  OrgUnitMismatch = 'Provided organizationalUnitId is not present in accessibleOrganizationalUnits',
  IncorrectSeriesDuration = 'incorrect_series_duration',
  IncorrectSeriesRules = 'incorrect_series_rules',
  NoShiftSeriesToCreate = 'No shift series to create',
  // Must match the backend UnauthorizedException('Tenant suspended') from the tenant kill-switch (WILP-12804).
  TenantSuspended = 'Tenant suspended',
}
